define('app/models/busca',['require','backbone'],function(require) {
    var Backbone = require('backbone');
    return new Backbone.Model({
        novo: false,
        sale: false,
        referencia: ''
    });
});
